import React, { Component } from 'react'
import SmoothCollapse from 'react-smooth-collapse'
import { connect } from 'react-redux'
import TaskMenu from './task-menu'

import { updateTask, saveTaskStatuses } from 'state/actions'
import { processStatuses } from 'state/selectors'

import BrainModal from 'components/brain-modal/brain-modal'

import Icon from 'components/icon/icon'
import copy from 'fast-copy'

class TaskStatus extends Component {
	state = {
		brainData: null
	}

	statusIndexIfExists = (item, selectedItems) => {
		return (selectedItems && selectedItems.includes(item.id))
	}

	clickStatus = status => {
		const {
			task,
			hasAi,
			updateTask,
			taskActivityHistory,
			column
		} = this.props

		let activity
		let historyStatusId = null

		let columnData = task.column_data ? copy(task.column_data[column.id]) : null

		if(columnData == status.id){
			columnData = null

			historyStatusId = status.id
			activity = 'REMOVE'
		}else{
			columnData = status.id
			
			historyStatusId = status.id
			activity = 'ADD'
		}

		if(hasAi){
			// this is pretty analogous to the 'activities' table, but I guess more immediate. For Hassl brain
			taskActivityHistory.push({
				activity,
				type: 'STATUS',
				taskId: task.id,
				targetId: historyStatusId
			})

			this.assessActionableBehaviour()
		}

		updateTask({
			...task,
			column_data: {
				...task.column_data,
				[column.id]: columnData
			}
		})
	}

	assessActionableBehaviour = _ => {
		// TODO: check milestone has more than 2 tasks
		// TODO: overwrite users??

		const {
			taskActivityHistory,
			task,
			openMenu,
			allStatuses,
			setBrainData,
			menuItems
		} = this.props

		if(!taskActivityHistory){
			return
		}

		const reversedActivityHistory = [
			...taskActivityHistory
		]

		reversedActivityHistory.reverse()

		let thisTaskStatusId = null
		let previousTaskStatusId = null
		let hasInvalidated = false
		let previousLoopedTaskId = null
		let previousLoopedOperation = null
		let previousTaskId = null
		let mostRecentOperation = null

		if(reversedActivityHistory.length){
			mostRecentOperation = reversedActivityHistory[0].activity
		}

		reversedActivityHistory.forEach(activity => {
			if(activity.type !== 'STATUS'){
				hasInvalidated = true
			}

			if(hasInvalidated){
				return
			}

			// from here we can assume it's in the same sequence of adding people
			if((!previousLoopedTaskId || previousLoopedTaskId === task.id) && activity.taskId === task.id && (!previousLoopedOperation || previousLoopedOperation === activity.activity)){
				if(activity.targetId){
					thisTaskStatusId = activity.targetId
				}
			}

			// If the task isn't this one, but we haven't set the previous, it's this.
			if(activity.taskId !== task.id && !previousTaskId){
				previousTaskId = activity.taskId
			}

			if(activity.taskId === previousTaskId && (!previousLoopedOperation || previousLoopedOperation === activity.activity)){
				if(activity.targetId){
					previousTaskStatusId = activity.targetId
				}
			}

			// at the end
			previousLoopedTaskId = activity.taskId
			previousLoopedOperation = activity.activity
		})

		if(thisTaskStatusId === previousTaskStatusId){
			const status = menuItems.find(loopedStatus => {
				return loopedStatus.id === thisTaskStatusId
			})

			const statusName = status ? status.name ? status.name : status.custom_name : ''

			const suggestion = mostRecentOperation == 'ADD' ? `Set every task in this milestone to <strong>${statusName}</strong>?` : `Remove <strong>${statusName}</strong> status from every task in this milestone?`

			// Just in case openMenu is cleared by selecting a user.
			setTimeout(_ => {
				openMenu('status',task.id, true)

				const brainData = {
					suggestion,
					operation: mostRecentOperation,
					statusId: thisTaskStatusId,
					isVisible: true
				}

				setBrainData(brainData)

				this.setState({
					brainData
				})
			},1)
		} 
	}

	closeBrainModal = (isActioned = false) => {
		const {
			milestone,
			updateTask,
			clearTaskActivityHistory,
			setBrainData,
			column
		} = this.props

		if(!this.state.brainData.isVisible && !isActioned){
			return 
		}

		const brainData = copy(this.state.brainData)

		brainData.isVisible = false
		setBrainData(null)

		this.setState({
			brainData
		})

		clearTaskActivityHistory()

		if(isActioned){
			let updatedMilestone = copy(milestone)
			
			updatedMilestone.tasks.forEach((task, index) => {
				const columnData = task.column_data ? task.column_data : {}

				let statusId = columnData && columnData[column.id] ? columnData[column.id] : null

				if(brainData.operation === 'ADD') {
					statusId = brainData.statusId
				} else if(brainData.operation === 'REMOVE'){
					if(statusId === brainData.statusId){
						statusId = null
					}
				}

				columnData[column.id] = statusId

				task.column_data = columnData

				// just in case? not sure if necessary
				updatedMilestone.tasks[index] = task
			})

			//console.log(updatedMilestone)

			// it'll automatically check whether it's an array.
			updateTask(updatedMilestone.tasks, 'from closing a brain modal in task-status')
		}
	}

	clickMenu = _ => {
		const {
			isDisabled,
			menuState,
			task,
			openMenu,
			column
		} = this.props

		if (!isDisabled) {
			if (menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == task.id) {
				openMenu(null)
			} else {
				if (task) {
					openMenu(column.id, task.id)
				}
			}
		}
	}

	getSelectedItem = _ => {
		const {
			task,
			column
		} = this.props

		if(task && column && task.column_data && task.column_data[column.id]){
			return task.column_data[column.id]
		}else{
			return null
		}
	}

	render() {
		const {
			allStatuses,
			column,
			currentProjectId,
			isDisabled,
			isSingle,
			menuItems,
			menuState,
			openMenu,
			saveTaskStatuses,
			task,
		} = this.props

		const {
			brainData
		} = this.state

		let isOpened = false
		let statusObject = null

		let className = 'task-status '

		let statusIconClass = 'status-icon'

		const selectedStatusId = this.getSelectedItem()

		if (!task || !selectedStatusId) {
			className += ' hidden'
		} else {
			statusObject = allStatuses[selectedStatusId]
			className += ' has-status';
			statusIconClass += ' colour-id-' + statusObject.colour_id
		}

		if (menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == task.id) {
			isOpened = true
			className += ' active'
		}

		let itemName = ''

		if (statusObject && menuItems && menuItems.length) {
			let selectedMenuItem = menuItems.find(item => {
				return item.id === statusObject.id
			})

			if (selectedMenuItem.custom_name) {
				itemName = selectedMenuItem.custom_name
			} else {
				itemName = selectedMenuItem.name
			}
		}

		if(isDisabled){
			className += ' disabled'
		}

		return (
			<a 
				className={className} 
				onClick={this.clickMenu}
				href="javascript:void(0)"
			>
				{ statusObject ?
					statusObject.colour_id == 3 ?
						<Icon name="check" />
						:
						<em className={statusIconClass}></em>
					: null
				}
				<span className="status-label">
					{ itemName ?
						itemName
						:
						'No status'
					}
				</span>
				{ task ?
					<div className={'smooth-collapse-container'}>
						<SmoothCollapse 
							heightTransition="0.15s ease" 
							expanded={isOpened}
							className="task-menu-collapse"
						>
							<TaskMenu 
								isOpened={isOpened} 
								dismissCallback={openMenu} 
								projectId={currentProjectId} 
								saveTaskStatuses={saveTaskStatuses} 
								column={column}
								type="staus" 
								menuItems={menuItems} 
								selectedMenuItems={selectedStatusId ? [selectedStatusId] : []} 
								selectCallback={this.clickStatus} 
								isSelectedCheck={this.statusIndexIfExists} 
								taskId={task.id} 
								type="status" 
								isSingle={isSingle}
							/>
						</SmoothCollapse>
					</div>
				: null }
				{ !isSingle ?
					<BrainModal 
						data={brainData} 
						closeCallback={this.closeBrainModal}
						direction="left"
					/>
				: null }
			</a>
		);
	}

}

const mapStateToProps = (state, props) => {
	return {
		allStatuses: state.account.entities.statuses,
		allProjects: state.account.entities.projects,
		currentProjectId: state.account.currentProjectId,
		menuItems: processStatuses(state, props)
	}
}

export default connect(mapStateToProps, { updateTask, saveTaskStatuses })(TaskStatus)



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/task/task-status.jsx